<template>
  <section class="v-filterSection">
    <div class="v-accordion" v-cloak>
      <button type="button" :title="label" @click="accordionToggle()"
        :class="['v-filterToggleButton', isOpened ? '_state-open' : '']"
      >
        <span>{{ label }}</span>
        <span class="v-filterToggleButton__icon"></span>
      </button>
      <transition name="v-accordion" @before-enter="beforeEnter" @enter="enter" @before-leave="beforeLeave" @leave="leave">
        <div class="v-accordion--target" :class="{ '_state-open': isOpened }" v-if="isOpened" ref="accordionTarget">
          <div class="v-accordion--body">
            <slot></slot>
          </div>
        </div>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: 'FilterAccordion',
  props: {
    isOpenedDefault: { type: Boolean, default: false },
    labelDefault: { type: String, default: function () {
        return this.$t("FilterAccordion.label_default")
      }
    }
  },
  data () {
    return {
      isOpened: this.isOpenedDefault,
      label: this.labelDefault,
    }
  },
  methods: {
    setInitialHeight: function () {
      if (this.isOpenedDefault === true && this.$refs.accordionTarget) {
        const height = this.$refs.accordionTarget.getBoundingClientRect().height
        this.$refs.accordionTarget.style.height = `${parseInt(height)}px`
      }
    },
    accordionToggle: function () {
      this.isOpened = !this.isOpened;
    },
    beforeEnter: function (el) {
      el.style.height = '0';
    },
    enter: function (el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeave: function (el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leave: function (el) {
      el.style.height = '0';
    }
  },
  mounted () {
    setTimeout(this.setInitialHeight, 2000)
  },
}
</script>

<style lang="scss" scoped>

.v-filterSection {
  border-top: 1px solid #d6d6d6;
  border-bottom: 1px solid #d6d6d6;

  &__heading {
    font-size: 10px;
  }
}

.v-filterToggleButton {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent;
  border: 0;
  color: inherit;
  font: inherit;
  padding: 0;
  outline: 0;
  letter-spacing: inherit;
  text-align: inherit;
  padding: 10px 0 10px;
  position: relative;
  display: block;
  width: 100%;
  font-size: 10px;

  &__icon {
    position: absolute;
    top: 0;
    right: 10px;
    bottom: 0;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid;
    margin: auto 0;
    transition: .3s transform;
    transition-timing-function: var(--animation-easing);
    opacity: .8;

    &::before,
    &::after {
      content: "";
      position: absolute;
      margin: auto;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      width: 7px;
      height: 0px;
      border-top: 1px solid;
      transition: .3s opacity;
      transition-timing-function: var(--animation-easing);
    }

    &::after {
      transform: rotate(90deg);
    }

  }

  &._state-open &__icon {
    transform: rotate(90deg);
    &::before {
      opacity: 0;
    }
  }
}

.v-accordion{
  &--target{
    overflow: hidden;
    transition: height 0.4s ease-in-out;
  }
  &--body{
    padding-top: 5px;
    padding-bottom: 20px;
  }
  &-enter-active{
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-name: v-accordion--anime__opend;
  }
  &-leave-active{
    animation-duration: 1s;
    animation-fill-mode: both;
    animation-name: v-accordion--anime__closed;
  }
}

@keyframes v-accordion--anime__opend {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
   }
}
@keyframes v-accordion--anime__closed {
  0% {
   opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>
